const ReservationForm = (initialData = {}) => ({
  // Alpine.js reactive state
  _formRef: null,
  closeBtn: null,
  _translatedErrors: initialData.translatedErrors || {},
  isSubmitted: false,
  isLoading: false,
  isSuccess: false,
  isError: false,
  isFormValid: false,
  requestError: false,
  // Global errors object for Alpine.js reactivity
  errors: {},
  // Form field values (x-model bindings)
  clientName: "",
  clientTelephone: "",
  clientAddress: "",
  clientEmail: "",
  salesPersonName: "",
  associatesEmail: "",
  neededBy: "",
  /**
   * Initialize the form, this could include fetching translations or setting up defaults
   */
  init() {
    this._translatedErrors;
  },
  /**
   * Validates individual field based on the value
   */
  validateField(fieldKey, value) {
    this.errors[fieldKey] = "";
    if (value === "") {
      this.errors[fieldKey] = this._translatedErrors[`${fieldKey}Required`];
      return false;
    }
    switch (fieldKey) {
      case "clientName":
      case "salesPersonName":
        if (!/^[\p{L}\s]+$/u.test(value)) {
          this.errors[fieldKey] = this._translatedErrors[`${fieldKey}Invalid`];
          return false;
        }
        break;
      case "clientTelephone":
        if (!/^\+?[1-9]{1}[0-9\s\-\(\)\.]{6,19}$/.test(value)) {
          this.errors[fieldKey] = this._translatedErrors[`${fieldKey}Invalid`];
          return false;
        }
        break;
      case "neededBy":
        if (new Date(value).getTime() <= (/* @__PURE__ */ new Date()).getTime()) {
          this.errors[fieldKey] = this._translatedErrors[`${fieldKey}Invalid`];
          return false;
        }
        break;
      case "clientEmail":
      case "associatesEmail":
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
          this.errors[fieldKey] = this._translatedErrors[`${fieldKey}Invalid`];
          return false;
        }
        break;
    }
    return true;
  },
  /**
   * Validates the entire form
   */
  _validateForm() {
    const allFields = [
      "clientName",
      "clientTelephone",
      "salesPersonName",
      "neededBy",
      "clientAddress",
      "clientEmail",
      "associatesEmail"
    ];
    allFields.forEach((field) => {
      const value = this.$refs[field].value.trim();
      this.validateField(field, value);
    });
    Object.keys(this.errors).forEach((key) => {
      if (this.errors[key] === null || this.errors[key] === void 0 || this.errors[key] === "") {
        delete this.errors[key];
      }
    });
    if (Object.keys(this.errors).length > 0) {
      return false;
    } else {
      return true;
    }
  },
  /**
   * Handles form submission
   */
  async handleSubmit(event) {
    var _a, _b, _c;
    event.preventDefault();
    this.closeBtn = this.$refs.closeButton;
    this.isSubmitted = true;
    if (!this._validateForm()) {
      this.isError = true;
      return;
    }
    this.isLoading = true;
    this.isSuccess = false;
    this.isError = false;
    this._formRef = event.target;
    try {
      const formData = new FormData(this._formRef);
      const body = JSON.stringify(Object.fromEntries(formData.entries()));
      const shopifyShop = window.Shopify.shop;
      const customerId = (_a = window.ShopifyAnalytics) == null ? void 0 : _a.meta.page.customerId;
      const encodedCustomerId = customerId ? btoa(String(customerId)) : customerId;
      const headers = {
        "Content-Type": "application/json",
        shop: shopifyShop
      };
      if (encodedCustomerId) {
        headers["customer-id"] = encodedCustomerId;
      }
      const response = await fetch(`${"https://diamond-service.jrdunn.com"}/reserve-diamond`, {
        method: "POST",
        headers,
        body
      });
      if (response.ok) {
        this.isSuccess = true;
        setTimeout(() => {
          this.isSuccess = false;
        }, 5e3);
        this._formRef.reset();
        this.isSubmitted = false;
        (_b = this.closeBtn) == null ? void 0 : _b.click();
      } else {
        this.requestError = true;
        throw new Error("Failed to submit");
      }
    } catch (error) {
      this.requestError = true;
      setTimeout(() => {
        this.requestError = false;
      }, 5e3);
      this._formRef.reset();
      this.isSubmitted = false;
      (_c = this.closeBtn) == null ? void 0 : _c.click();
    } finally {
      this.isLoading = false;
    }
  }
});
const ProductRequestForm = () => ({
  isLoading: false,
  isSuccess: false,
  isError: false,
  /**
   * Handles form submission
   */
  async handleSubmit(event) {
    this.isLoading = true;
    this.isSuccess = false;
    this.isError = false;
    const form = event.target;
    try {
      const formData = new FormData(form);
      const body = JSON.stringify(Object.fromEntries(formData.entries()));
      const response = await fetch(`${"https://diamond-service.jrdunn.com"}/request-tudor-watch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body
      });
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const result = await response.json();
      if (result.success) {
        this.isSuccess = true;
        form.reset();
      } else {
        this.isError = true;
      }
    } catch (error) {
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }
});
const DELIVERY_ESTIMATE_MESSAGE = "In stock and ready to be shipped";
const REQUEST_FORM_MESSAGE = "Contact us";
const MAX_POLL_ATTEMPTS = 20;
const POLL_DELAY_MS = 500;
const FETCH_TIMEOUT_MS = 1e4;
const fetchWithTimeout = async (url, options = {}, timeout = FETCH_TIMEOUT_MS) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal
    });
    clearTimeout(timeoutId);
    return response;
  } catch (error) {
    clearTimeout(timeoutId);
    throw error;
  }
};
const getCustomerData = () => {
  return window.customerData || null;
};
const buildShippingParams = (address) => {
  const params = new URLSearchParams();
  if (address.zip) params.append("shipping_address[zip]", address.zip);
  if (address.country_name || address.country_code) {
    params.append("shipping_address[country]", address.country_name || address.country_code || "");
  }
  if (address.province || address.province_code) {
    params.append("shipping_address[province]", address.province || address.province_code || "");
  }
  if (address.city) params.append("shipping_address[city]", address.city);
  return params;
};
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const pollAsyncShippingRates = async (maxAttempts = MAX_POLL_ATTEMPTS, delayMs = POLL_DELAY_MS) => {
  var _a;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const response = await fetchWithTimeout("/cart/async_shipping_rates.json");
      if (!response.ok) {
        if (attempt < maxAttempts) {
          await delay(delayMs);
          continue;
        }
        return null;
      }
      const data = await response.json();
      if (((_a = data.shipping_rates) == null ? void 0 : _a.length) > 0) {
        return data.shipping_rates;
      }
      if (data.status === "pending" || data.status === "calculating") {
        await delay(delayMs);
        continue;
      }
      return null;
    } catch (error) {
      if (attempt < maxAttempts) {
        await delay(delayMs);
        continue;
      }
      return null;
    }
  }
  return null;
};
const getCart = async () => {
  try {
    const response = await fetchWithTimeout("/cart.js");
    if (!response.ok) return null;
    return await response.json();
  } catch {
    return null;
  }
};
const addToCart = async (variantId) => {
  try {
    const response = await fetchWithTimeout("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    return response.ok;
  } catch {
    return false;
  }
};
const removeFromCart = async (itemKey) => {
  try {
    const response = await fetchWithTimeout("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    });
    return response.ok;
  } catch {
    return false;
  }
};
const prepareShippingRates = async (address) => {
  try {
    const params = buildShippingParams(address);
    const response = await fetchWithTimeout(
      `/cart/prepare_shipping_rates.json?${params.toString()}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      }
    );
    return response.ok;
  } catch {
    return false;
  }
};
const formatShortDate = (dateString) => {
  let cleaned = dateString.replace(/^Estimated Delivery:\s*/i, "").trim();
  return cleaned.replace(/,?\s*\d{4}\s*$/g, "").trim();
};
const selectBestShippingRate = (rates) => {
  if (!rates.length) return null;
  const sorted = [...rates].sort((a, b) => (b.price || 0) - (a.price || 0));
  return sorted[0];
};
const DeliveryEstimate = (variantId, isAvailable, isRequestForm = false) => {
  const state = {
    variantId,
    isAvailable,
    isLoading: false,
    deliveryDate: null,
    deliveryMessage: isRequestForm ? REQUEST_FORM_MESSAGE : DELIVERY_ESTIMATE_MESSAGE,
    customerZip: null,
    hasAddress: false,
    isRequestForm,
    init() {
      if (this.isRequestForm) {
        this.deliveryMessage = REQUEST_FORM_MESSAGE;
        return;
      }
      const customerData = getCustomerData();
      if (customerData == null ? void 0 : customerData.default_address) {
        this.hasAddress = true;
        this.customerZip = customerData.default_address.zip || null;
      }
      if (!this.isAvailable) {
        this.deliveryMessage = "Available for order";
        return;
      }
      if (this.hasAddress && this.customerZip) {
        this.fetchDeliveryEstimate();
      }
      document.addEventListener("variant:changed", (e) => {
        var _a;
        const newVariantId = (_a = e.detail) == null ? void 0 : _a.variantId;
        if (newVariantId && newVariantId !== this.variantId) {
          this.variantId = newVariantId;
          if (this.hasAddress && this.customerZip) {
            this.fetchDeliveryEstimate();
          }
        }
      });
    },
    async fetchDeliveryEstimate() {
      if (this.isRequestForm) {
        this.deliveryMessage = REQUEST_FORM_MESSAGE;
        return;
      }
      if (!this.hasAddress || !this.customerZip) {
        this.deliveryMessage = DELIVERY_ESTIMATE_MESSAGE;
        return;
      }
      this.isLoading = true;
      try {
        const customerData = getCustomerData();
        if (!(customerData == null ? void 0 : customerData.default_address)) {
          this.deliveryMessage = DELIVERY_ESTIMATE_MESSAGE;
          return;
        }
        const address = customerData.default_address;
        const cart = await getCart();
        if (!cart) {
          this.deliveryMessage = DELIVERY_ESTIMATE_MESSAGE;
          return;
        }
        const existingItem = cart.items.find((item) => item.variant_id === this.variantId);
        let itemKey = (existingItem == null ? void 0 : existingItem.key) || null;
        let shouldRemove = false;
        if (!existingItem) {
          const added = await addToCart(this.variantId);
          if (!added) {
            this.deliveryMessage = DELIVERY_ESTIMATE_MESSAGE;
            return;
          }
          shouldRemove = true;
          const updatedCart = await getCart();
          const addedItem = updatedCart == null ? void 0 : updatedCart.items.find((item) => item.variant_id === this.variantId);
          itemKey = (addedItem == null ? void 0 : addedItem.key) || null;
        }
        try {
          const prepared = await prepareShippingRates(address);
          if (!prepared) {
            this.deliveryMessage = DELIVERY_ESTIMATE_MESSAGE;
            return;
          }
          const rates = await pollAsyncShippingRates();
          if (rates == null ? void 0 : rates.length) {
            const bestRate = selectBestShippingRate(rates);
            if (bestRate == null ? void 0 : bestRate.description) {
              const shortDate = formatShortDate(bestRate.description);
              this.deliveryDate = shortDate;
              this.deliveryMessage = `Estimated Delivery to ${this.customerZip}: ${shortDate}`;
            } else {
              this.deliveryMessage = DELIVERY_ESTIMATE_MESSAGE;
            }
          } else {
            this.deliveryMessage = DELIVERY_ESTIMATE_MESSAGE;
          }
        } finally {
          if (shouldRemove && itemKey) {
            await removeFromCart(itemKey);
          }
        }
      } catch (error) {
        this.deliveryMessage = DELIVERY_ESTIMATE_MESSAGE;
      } finally {
        this.isLoading = false;
      }
    }
  };
  return state;
};
document.addEventListener("alpine:init", () => {
  Alpine.data("ReservationForm", ReservationForm);
  Alpine.data("ProductRequestForm", ProductRequestForm);
  Alpine.data("DeliveryEstimate", DeliveryEstimate);
});
